<template>
  <el-container>
    <el-header>
      <el-row
        style="
          box-shadow: rgb(243 243 243) 0px 0px 12px 3px;
          height: 100%;
          width: 100%;
        "
      >
        <div style="width: 100%; height: 60px" class="flex">
          <el-row style="width: 50%; height: 100%">
            <el-col :span="2">
              <img class="img-one" src="@/assets/excavationsImg/logo.svg" alt />
            </el-col>
            <el-col :span="22" class="text-4">构件管理云平台 </el-col>
          </el-row>
          <div
            style="width: 50%; height: 100%; justify-content: end"
            class="flex"
          >
            <div
              class="flexCenter"
              @click="openMyInfo"
              v-if="
                $store.state.roles.includes('user') ||
                $store.state.roles.includes('company')
              "
              style="cursor: pointer; width: 10%"
            >
              <el-badge :value="value" class="item">
                <img
                  v-if="$store.state.roles.includes('user')"
                  style="display: block"
                  src="../../assets/img/Frame.png"
                  alt=""
                />
                <img
                  v-else
                  style="display: block"
                  src="../../assets/img/companyinfoicon.png"
                  alt=""
                />
              </el-badge>
              <div style="margin-left: 10px" class="textOverflow">
                {{
                  $store.state.roles.includes("user") ? "个人中心" : "企业中心"
                }}
              </div>
            </div>
            <div
              style="height: 100%; cursor: pointer; width: 16%"
              class="flexCenter"
            >
              <div
                style="height: 50%; width: 4px; border-left: 2px solid #e9e9e9"
              ></div>
              <el-dropdown
                placement="bottom-start"
                style="width: 60%; margin-left: 10px"
                trigger="click"
              >
                <span class="el-dropdown-link flexCenter">
                  <div style="width: 40px">
                    <img
                      :src="
                        $store.state.userInfo.user07
                          ? $store.state.baseUrl + $store.state.userInfo.user07
                          : ''
                      "
                      style="display: block; border-radius: 50%"
                      :onerror="errorImg"
                      class="user-avatar"
                      width="40"
                      height="40"
                    />
                  </div>
                  <div
                    :title="$store.state.userInfo.user02"
                    class="textOverflow"
                    style="
                      width: 70%;
                      height: 100%;
                      font-size: 14px;
                      text-align: left;
                      margin-left: 5px;
                    "
                  >
                    {{
                      $store.state.userInfo.user02 == ""
                        ? "诸葛孔明"
                        : $store.state.userInfo.user02
                    }}
                  </div>
                  <!-- <img :src="$store.state.UserImgs" style="display:block" class="user-avatar" width="60"/> -->
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item icon="el-icon-user" @click.native="my">
                  <span>个人中心</span>
                </el-dropdown-item> -->
                  <el-dropdown-item
                    icon="el-icon-edit"
                    @click.native="Updatepwd"
                  >
                    <span>修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="el-icon-switch-button"
                    @click.native="out"
                  >
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-row>
    </el-header>
    <el-container style="padding: 10px; background-color: #f5f7fe">
      <el-main style="overflow: hidden">
        <router-view
          v-if="viewShow"
          style="overflow: hidden; height: 100%"
          class="animate__animated animate__backInDown"
          ref="view"
          :class="is ? 'animate__fadeInDown' : 'animate__fadeInUp'"
        ></router-view>
      </el-main>
    </el-container>
    <!-- 个人中心弹出框 -->
    <el-dialog title="个人中心" :visible.sync="personal" width="65%" center>
      <personal @aaa="unSubmit"></personal>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="UpdatepwdDialog"
      width="32%"
      center
    >
      <el-form
        :model="updateform"
        class="width90-ma-auto"
        style="width: 90%; margin: 0 auto"
        :rules="rulespwd"
        ref="ruleForm"
      >
        <el-form-item prop="oldpwd" label="旧密码" label-width="80px">
          <el-input
            v-model="updateform.oldpwd"
            type="password"
            autocomplete="off"
            show-password
            clearable
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd" label="新密码" label-width="80px">
          <el-input
            v-model="updateform.newpwd"
            type="password"
            autocomplete="off"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          required
          prop="newpwd1"
          label="确认密码"
          show-password
          clearable
          label-width="80px"
        >
          <el-input
            v-model="updateform.newpwd1"
            type="password"
            autocomplete="off"
            placeholder="再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdatepwdDialog = false">取 消</el-button>
        <el-button type="primary" @click="UpdatepwdDialogBtn('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import personal from "../my/personal";
import {
  ExitUser,
  GetMyIndex,
  GetRoleList,
  UpdatePwd,
  GetMsginform,
  GetCompany,
} from "@/setAxios";
import { mapGetters } from "vuex";
export default {
  components: {
    personal,
  },
  name: "admin",
  data() {
    let _this = this;
    var validatePass2 = (rule, value, callback) => {
      if (value === "" && value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== _this.updateform.newpwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (_this.updateform.newpwd1 !== "" && _this.updateform.newpwd1) {
          _this.$refs.ruleForm.validateField("ruleForm");
        }
        callback();
      }
    };
    return {
      rulespwd: {
        newpwd1: [
          { required: true, message: "请重复输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
        oldpwd: [
          { required: true, message: "请输入旧密码", trigger: "blur" },

          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newpwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
      },
      personal: false,
      is: true,
      viewShow: true,
      viewShows: true,
      // 这里是修改密码对话框
      UpdatepwdDialog: false,
      updateform: {
        oldpwd: null,
        newpwd: null,
        newpwd1: null,
      },
      JobName: "待判断",
      ProjectList: [],
      // 这里是排序
      rank: "",
      // 是否企管
      ifEnterprise: this.$store.state.ifEnterprise,
      // 是否项管
      isProject: this.$store.state.isProject,
      // 是否普通用户
      isUser: false,
      controlClick: false, //是否点击控制台
      Company: "",
      CompanyList: [],
      manager: "true",
      query: "",
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      testList: [],
      listData: [],
      item: null,
      NormalScenceInspectionList: [],
      ScenceInspectionList: [],
      showXjList: [],
      option: {
        step: 1,
        limitMoveNum: 9,
        openTouch: false,
        waitTime: 1,
        direction: 1,
        singleHeight: 35,
      },
      value: "",

      xidIsChange: false,
      roleNameIsChange: false,
      roleNameModel: "",
      plain: false,
      paths: "",
    };
  },
  updated() {},
  mounted() {},
  created() {
    if (this.paths == "" && this.$route.name == "home") {
      this.paths = this.$router.options.routes[0].children[0].path;
      this.$router.push({ path: this.paths });
    } else {
      this.paths = this.$route.fullPath;
    }
  },
  //利用计算属性
  computed: {
    errorImg() {
      if (!this.$store.state.userInfo.user03) {
        return (
          'this.src="' + require("../../assets/img/ComanyDefault.png") + '"'
        );
      } else {
        return (
          'this.src="' +
          require("../../assets/img/用户头像-" +
            this.$store.state.userInfo.user03 +
            ".png") +
          '"'
        );
      }
    },
    ...mapGetters(["userInfo"]),
  },
  //监听执行
  watch: {
    xidNameupdata(newVal, oldVal) {
      // 用来判断岗位是不是需要重新加载，如果项目发生改变则职位true，在需要改变的时候一定要先判断项目发生改变了没
      this.xidIsChange = true;
      this.GetMyIndex();
    },
    roleName() {
      this.roleNameModel = this.$store.state.roleName;
      this.roleNameIsChange = true;
    },
    xidUpdate() {},
    $route: {
      handler(a, b) {
        if (a.name == "UserInfo") {
          this.is = true;
        } else {
          this.is = false;
        }
        if (this.$store.state.roles.includes("user")) {
          this.GetMsginform();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  provide() {
    return {
      dataGo: this.setitem,
      delitem: this.delitem,
    };
  },
  updated() {},
  methods: {
    // 消息通知 得到列表
    GetMsginform() {
      GetMsginform().then((res) => {
        this.value = res.Data.filter(
          (w) => w.msif03 != null && w.msif06 == null
        ).length;
        this.value = this.value == 0 ? "" : this.value;
      });
    },
    openMyInfo() {
      if (this.$store.state.roles.includes("user")) {
        this.$router.replace("/UserInfo");
      } else {
        this.$router.replace("/CompanyInfo");
      }
    },
    cut(v) {
      this.paths = v.path;
      this.viewShow = false;
      this.$nextTick(() => {
        this.viewShow = true;
      });
    },
    setitem() {
      return JSON.stringify(this.item);
    },
    delitem() {
      this.item = null;
    },
    routerGo(item, type) {
      this.$router.push({
        name: type ? "everydaySceneTour" : "sceneTour",
        path: type ? "/everydaySceneTour" : "/sceneTour",
        params: item,
      });
      this.item = item;
      this.$store.state.RouterPath = type ? "everydaySceneTour" : "sceneTour";
    },
    unSubmit() {
      this.personal = false;
    },
    changeJobs(data) {
      this.$store.state.roleName = data.roleName;
      this.roleNameModel = data.roleName;
      this.$store.state.permissions =
        data.roleRight == null ? [] : data.roleRight;
    },
    // 获取公司下的项目
    GetMyIndex() {
      let params = {
        secahword: "",
        uid: localStorage.getItem("id"),
      };
      GetMyIndex({ params }).then((res) => {
        this.ProjectList = res.Data;
        if (!localStorage.xid && !res.Data.length) {
          return false;
        }
        let params2 = {
          xid: localStorage.xid || res.Data[0].proj01,
          uid: localStorage.id,
        };
        GetRoleList(params2).then((res) => {
          this.$store.state.jobs = res.Data;
          if (this.xidIsChange) {
            this.$store.state.roleName = res.Data[0].roleName;
            this.xidIsChange = false;
          }
          if (res.Data[0].roleRight != null && this.roleNameIsChange) {
            this.$store.state.permissions = res.Data[0].roleRight.split(",");
            this.roleNameIsChange = false;
          } else {
            this.roleNameIsChange = false;
          }
        });
      });
    },
    // 这里记得把项目ID保存下来
    changeProject(item) {
      if (item.prou06 == 1) {
        this.$store.state.isProject = true;
        this.isUser = false;
      } else {
        this.$store.state.isProject = false;
        this.isUser = true;
      }
      localStorage.setItem("xid", item.proj01);
      this.$store.state.xid = item.proj01;
      this.$store.state.isClickProject = true;
      this.$store.state.xidName = item.proj03;
      let params = {
        xid: item.proj01,
        uid: localStorage.id,
      };
      GetRoleList(params).then((res) => {
        this.$store.state.jobs = res.Data;
        this.roleNameModel = res.Data[0].roleName;
        this.$store.state.roleName = res.Data[0].roleName;
        if (res.Data[0].roleRight !== null) {
          this.$store.state.permissions = res.Data[0].roleRight.split(",");
        } else {
          this.$store.state.permissions = [];
        }
      });
    },
    // 获取用户所属公司
    async GetUserCompanyList() {
      let res = await GetCompany();
      this.CompanyList = res.Data;
      this.JobName = res.Data.DeptJob;
      this.$store.state.Company = res.Data.comp02;
      this.$store.state.pid = res.Data.comp01;
      localStorage.setItem("pid", res.Data.comp01);
      // this.$store.state.companyLogo =
      // this.$store.state.baseUrl + res.Data.comp04;
      this.GetMyIndex();
    },
    out() {
      ExitUser().then((res) => {
        if (res.Code == 1) {
          localStorage.clear();
          sessionStorage.clear();
          this.$store.state.roles = [];
          this.$store.state.roleId = "";
          this.$message({
            type: "success",
            message: "退出成功",
          });
          location.href = "#/login";
          // this.$router.push({
          //   path: "/login",
          // });
          // location.reload();
        }
      });
    },
    enterpriseIndex() {
      this.$store.state.isClickProject = false;
      this.$store.state.isProject = false;
      this.controlClick = false;
      this.$router.push({
        path: "enterprise",
      });
    },
    control() {
      this.$store.state.isClickProject = false;
      this.controlClick = true;
      this.$router.push({
        path: "/enterpriseManagement",
      });
    },
    project() {
      this.$router.push({
        path: "/projectControl",
      });
    },
    userControls() {
      this.$router.push({
        path: "/userControl",
      });
    },
    // 这里是个人中心
    my() {
      this.personal = true;
    },
    // 这里是修改密码
    Updatepwd() {
      this.updateform = this.$options.data.call(this).updateform;
      this.UpdatepwdDialog = true;
    },
    // 这里是修改密码确定按钮
    UpdatepwdDialogBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let old = this.updateform.oldpwd;
          let news = this.updateform.newpwd;
          let id = this.userInfo.user01;
          let params = {
            oldpwd: old,
            newpwd: news,
            uid: id,
          };
          UpdatePwd(params).then((res) => {
            if (res.Code === 1) {
              this.$message({
                type: "success",
                message: "密码修改成功",
              });
            } else {
              this.$message.error("旧密码不正确");
            }
          });
          this.UpdatepwdDialog = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-container {
  width: 100%;
  height: 100%;
  box-shadow: none;
  .el-main {
    padding: 0;
    height: 100%;
  }
}
/deep/.el-dialog {
  border-radius: 10px;
}
/deep/.el-menu-item {
  margin: 10px 0;
}
/deep/.el-menu-item:nth-of-type(1) {
  margin: 0;
}

.el-menu-item:hover {
  background-color: #e0efff;
}
.is-active {
  background-color: white;
  border-radius: 50px 0 0 50px;
  font-weight: 700;
}
.el-menu li {
  border-radius: 50px 0 0 50px;
}
.el-header {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0px;
  .el-col-1 {
    // margin-left: 30px;
    img {
      // height: 60px;
    }
  }
  .text-4 {
    font-weight: 700;
    font-style: normal;
    color: #000000;
    font-size: 20px;
    text-align: left;
  }
}

.el-aside {
  background-color: #bfcbd9;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.view {
  background-color: #f5f7fe;
  width: auto;
  padding: 20px;
  height: calc(100vh - 60px);
}
/deep/.el-menu {
  background-color: transparent;
}

.right-menu {
}

// 新增
.img-one {
  height: 30px;
  border-radius: 3px;
}

.box-two {
  font-weight: 700;
  float: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
}
</style>

